"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var DocumentCard_base_1 = require("./DocumentCard.base");
var DocumentCard_styles_1 = require("./DocumentCard.styles");
exports.DocumentCard = Utilities_1.styled(DocumentCard_base_1.DocumentCardBase, DocumentCard_styles_1.getStyles, undefined, { scope: 'DocumentCard' });
//# sourceMappingURL=DocumentCard.js.map


//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib-commonjs/components/DocumentCard/DocumentCard.js
// module id = 941
// module chunks = 0